export default __webpack_public_path__ + "static/media/3.e0839b01.png";